module.exports = __webpack_public_path__ + "media/images/photos/12-66004686c4600b64f19ef866bc287689.jpg";